import { useCallback, useMemo, useState } from "react";
var useGetMergeFields = function () {
    var _a = useState([]), mergeFieldsData = _a[0], setMergeFieldsData = _a[1];
    var getMergeFields = useCallback(function (responseData) {
        // const limitedData = responseData.slice(0, 2);
        var mergeFieldsData = [];
        for (var _i = 0, responseData_1 = responseData; _i < responseData_1.length; _i++) {
            var item = responseData_1[_i];
            for (var _a = 0, _b = Object.entries(item); _a < _b.length; _a++) {
                var _c = _b[_a], schemaName = _c[0], schemaData = _c[1];
                var group = {
                    definitions: [],
                    groupId: schemaName,
                    groupLabel: schemaName,
                };
                var schemaFields = schemaData;
                for (var _d = 0, _e = Object.entries(schemaFields); _d < _e.length; _d++) {
                    var fieldName = _e[_d][0];
                    var cleanFieldName = fieldName.replace(/~/g, "");
                    group.definitions.push({
                        id: "".concat(schemaName, ".").concat(cleanFieldName),
                        label: "".concat(schemaName, ".").concat(cleanFieldName),
                    });
                }
                mergeFieldsData.push(group);
            }
            setMergeFieldsData(mergeFieldsData);
        }
    }, []);
    return useMemo(function () { return ({
        getMergeFields: getMergeFields,
        mergeFieldsData: mergeFieldsData,
    }); }, [getMergeFields, mergeFieldsData]);
};
export default useGetMergeFields;
